import _ from "underscore";
import $ from "jquery";
import render from "../../utilities/render";
import {setElementsFromScope, show, hide, insertTextAndClean, combineElements,insertValAndManageFocus} from "../../utilities/selectorHelpers";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
const confirmationModalHtml = require("./html/confirmationModal.html");

const scopeElementsMap = {
  retPrefix: '.ret-prefix',
  retFirstName: '.ret-first-name',
  retLastName: '.ret-last-name',
  retEmail: '.ret-email',
  affMerchantSwitchery: '#affMerchantSwitchery',
  insightFeedSwitchery: '#insightFeedSwitchery',
  affMerchantName: '#aff-merchant-name',
  country: '.ret-country',
  address1: '.ret-address1',
  address2: '.ret-address2',
  city: '.ret-city',
  state: '.ret-state',
  nonUSCAstate: '.ret-state-text',
  zipCode: '.ret-zip-code',
  county: '.ret-county',

  officeCounryCode: ".ret-office-country-code",
  officeAreaCode: ".ret-office-area-code",
  officePhone: ".ret-office-phone",
  officeExt: ".ret-office-ext",

  mobileCounryCode: ".ret-mobile-country-code",
  mobileAreaCode: ".ret-mobile-area-code",
  mobilePhone: ".ret-mobile-phone",

  commercialAddrFlag: "commercial-addr-flag",
  masterAccountSection :'.master-account-section',
  masterAccountToggleCheckbox : '.master-account-toggle-checkbox',
  managedByMasterAccountSection : '.managed-by-master-account-section',
  managedByMasteraccountToggleCheckbox : '.managed-by-masteraccount-toggle-checkbox',
  masteraccountDropdown : '.masteraccount-dropdown',

  officeCountryCodeBill: '.ret-office-country-code-bill',
  officePhoneBill: '.ret-office-phone-bill',
  officeAreaCodeBill: '.ret-office-area-code-bill',
  mobileCountryCodeBill: '.ret-mobile-country-code-bill',
  mobilePhoneBill: '.ret-mobile-phone-bill',
  mobileAreaCodeBill: '.ret-mobile-area-code-bill',

  officeCountryCodeShip: '.ret-office-country-code-ship',
  officePhoneShip: '.ret-office-phone-ship',
  officeAreaCodeShip: '.ret-office-area-code-ship',
  mobileCountryCodeShip: '.ret-mobile-country-code-ship',
  mobilePhoneShip: '.ret-mobile-phone-ship',
  mobileAreaCodeShip: '.ret-mobile-area-code-ship',
  };

 const elementsMap = {
   companyName: '.company-name',
   taxId: '.tax-id',
   fontanaFedExId :".Fontana-fedex-id",
   greenwoodFedexId:".Greenwood-fedex-id",
   facId1:".facId-1",
   facId2:".facId-2",
   primaryUrl: '.primary-url',
   fedexCanCall: '.fedex-can-call',
   sharePrimarySwitch: '.switch-share-primary',
   revCompanyName: '.revCompanyName',
   revFontanaFedExId:".revFontanaFedExId",
   revGreenwoodFedExId:".revGreenwoodFedExId",
   revTaxId: '.revTaxId',
   revPrimaryUrl: '.revPrimaryUrl',
   revContactPersonName: '.revContactPersonName',
   revEmailAddress: '.revEmailAddress',
   revMobileNumber: '.revMobileNumber',
   revOfficeNumber: '.revOfficeNumber',
   merchantName: '.merchantName',
   merchantNames: '.merchantNames',
   //addressValidationDiv:'.address-toggler',
   insightTogglerDiv:'.insight-toggler',
   submitBtn: '.submit-btn',
   submitConfirmationBtn: '.submit-confirmation-btn',
   revSupplychainfacilities : '.revSupplychainfacilities',
   revShippingServices : '.revShippingServices',
   revTier:'.revTier',
   merchantTier:'.merchant-tier',
   directBillTogglerDiv:'.directbill-toggler',
   fuelSurchrgDiscTogglerDiv:'.fuelsurchrg-toggler'

 }

export default function ReviewTab(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const primaryTab = wizardElement.find('.primary-information-tab');
  const shippingTab = wizardElement.find('.shipping-information-tab');
  const billingTab = wizardElement.find('.billing-information-tab');
  const reviewTab = wizardElement.find('.review-tab');
  const reviewPrimarySection = reviewTab.find('.primary-info-section');
  const reviewShippingSection = reviewTab.find('.shipping-info-section');
  const reviewBillingSection = reviewTab.find('.billing-info-section');
  const submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();
  const retailerObj = wizardElement.data("retailer-obj");
  const renderUrl = wizardElement.data("render-url");
  const submitUrl = wizardElement.data("submit-url");
  const supplychainFacilities = wizardElement.data('supplychain-facilities');
  const shippingServices = wizardElement.data('shipping-services');
  const isExistingRetailer = _.isObject(retailerObj);
  const els = {};
  const elsPrimarySection = {};
  const elsBillingSection = {};
  const elsShippingSection = {};
  const elsReviewPrimarySection = {};
  const elsReviewShippingSection = {};
  const elsReviewBillingSection = {};

  let confirmationModal = $(confirmationModalHtml);
  let contactName, mobileNumber, officeNumber;
  let retailer = {};
  
  
  self.init = function(){
    render();
  };

  self.didNavigateToForm = function(){
    updateSelf();
  };

  function render(){
    setElements();
    bindElements();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, wizardElement);
    setElementsFromScope(elsPrimarySection, scopeElementsMap, primaryTab);
    setElementsFromScope(elsShippingSection, scopeElementsMap, shippingTab);
    setElementsFromScope(elsBillingSection, scopeElementsMap, billingTab);

    setElementsFromScope(elsReviewPrimarySection, elementsMap, reviewPrimarySection);
    setElementsFromScope(elsReviewPrimarySection, scopeElementsMap, reviewPrimarySection);

    setElementsFromScope(elsReviewShippingSection, elementsMap, reviewShippingSection);
    setElementsFromScope(elsReviewShippingSection, scopeElementsMap, reviewShippingSection);

    setElementsFromScope(elsReviewBillingSection, elementsMap, reviewBillingSection);
    setElementsFromScope(elsReviewBillingSection, scopeElementsMap, reviewBillingSection);
    wizardElement.append(confirmationModalHtml);
  }

  function bindElements() {
    els.submitBtn.on("click", showConfirmationModal);
    confirmationModal.find(elementsMap.submitConfirmationBtn).on("click", onSubmit);
  }

  function updateSelf(){
    if(isExistingRetailer){
      //deep copy
      retailer = jQuery.extend(true, {}, retailerObj)      
    }

    retailer.retailerAddresses = [];
    retailer.retailerShipping = [];

    //Primary
    updatePrimaryUniqueInfo(elsPrimarySection);
    updateOtherInfo(elsReviewPrimarySection, elsPrimarySection, 'Primary');

    //Shipping
    const shippingTabSwitchElement = shippingTab.find(elementsMap.sharePrimarySwitch);
    const shippingTabSwitchElementFlag = shippingTabSwitchElement.prop("checked");
    if(shippingTabSwitchElementFlag){
      updateOtherInfo(elsReviewShippingSection, elsPrimarySection, 'Shipping');
    }else{
      updateOtherInfo(elsReviewShippingSection, elsShippingSection, 'Shipping');
    }

    //Billing
    const billingTabSwitchElement = billingTab.find(elementsMap.sharePrimarySwitch);
    const billingTabSwitchElementFlag = billingTabSwitchElement.prop("checked");
    if(billingTabSwitchElementFlag){
      updateOtherInfo(elsReviewBillingSection, elsPrimarySection, 'Billing');
    }else{
      updateOtherInfo(elsReviewBillingSection, elsBillingSection, 'Billing');
    }
  }

  function updatePrimaryUniqueInfo(elsPrimarySection){
    elsReviewPrimarySection.revCompanyName.html(els.companyName.val());
    elsReviewPrimarySection.revTaxId.html(els.taxId.val());
    elsReviewPrimarySection.revFontanaFedExId.html(els.fontanaFedExId.val());
    elsReviewPrimarySection.revGreenwoodFedExId.html(els.greenwoodFedexId.val());        
    elsReviewPrimarySection.revPrimaryUrl.html(els.primaryUrl.val());
    elsReviewPrimarySection.revPrimaryUrl.prop('href', els.primaryUrl.val());
    elsReviewPrimarySection.revSupplychainfacilities.empty();
    elsReviewPrimarySection.revShippingServices.empty();
    elsReviewPrimarySection.revTier.html(els.merchantTier.find("option:selected").text());

    $.each($(".supply-chain-fac"), function(ind, elem){
      let facilityNameDiv;
      if($(elem).prop("checked")){
        let mVal = $(elem).val();
        facilityNameDiv = ` 
        <div>
            ${mVal}
        </div>`
       }

       elsReviewPrimarySection.revSupplychainfacilities.append(facilityNameDiv);

       const response = _.map(supplychainFacilities, (supplychainFacilityItem) => {
        if(supplychainFacilityItem.facName == $(elem).val() && $(elem).prop("checked")){
          addFacilityAddressDetails(supplychainFacilityItem,'Y');
         }else if(supplychainFacilityItem.facName == $(elem).val() && !$(elem).prop("checked")){
          addFacilityAddressDetails(supplychainFacilityItem,'N');
         }
      });
    });

    $.each($(".shipping-serv"), function(ind, elem){
      let facilityNameDiv;
      if($(elem).prop("checked")){
        let mVal = $(elem).val();
        facilityNameDiv = ` 
        <div>
            ${mVal}
        </div>`
       }

      elsReviewPrimarySection.revShippingServices.append(facilityNameDiv);

      const response = _.map(shippingServices, (shippingServicesItem) => {
        if(shippingServicesItem.cdmMeaning == $(elem).val() && $(elem).prop("checked")){
          addShippingAddressDetails(shippingServicesItem,'Y');
         }else if(shippingServicesItem.cdmMeaning == $(elem).val() && !$(elem).prop("checked")){
          addShippingAddressDetails(shippingServicesItem,'N');
         }
      });
    });
    els.merchantNames.empty();
    $.each($(".affMerchantNameValue"), function(ind, elem){
      let mVal = $(elem).val();
      let merchantNameDiv = ` <div class="divider-group">
                  <div class="row">
                <div class="col-xs-3">
                  <div class="merchantName">
                    ${mVal}
                  </div>
                </div>
                </div>
              </div>`;
      els.merchantNames.append(merchantNameDiv);
    });
    els.insightTogglerDiv.empty();
    let insightYesSpan= `<span class="q-pretty-pill-tag q-ppt-blue q-ppt-pad-lg">Yes</span>`;
    let insightNoSpan = `<span class="q-pretty-pill-tag q-ppt-blue-border q-ppt-pad-lg">No</span>`;
    if($('.primary-information-tab .insight-feed-switch').is(":checked")){
      els.insightTogglerDiv.append(insightYesSpan);
    } else {
      els.insightTogglerDiv.append(insightNoSpan);
    }
  
    els.directBillTogglerDiv.empty();
    let directBillYesSpan= `<span class="q-pretty-pill-tag q-ppt-blue q-ppt-pad-lg">Yes</span>`;
    let directBillNoSpan = `<span class="q-pretty-pill-tag q-ppt-blue-border q-ppt-pad-lg">No</span>`;

    if($('.primary-information-tab .direct-bill-switch').is(":checked")){
     els.directBillTogglerDiv.append(directBillYesSpan);
    } else {
      els.directBillTogglerDiv.append(directBillNoSpan);
    }


    els.fuelSurchrgDiscTogglerDiv.empty();
    let fuelSurchrgDiscYesSpan= `<span class="q-pretty-pill-tag q-ppt-blue q-ppt-pad-lg">Yes</span>`;
    let fuelSurchrgDiscNoSpan = `<span class="q-pretty-pill-tag q-ppt-blue-border q-ppt-pad-lg">No</span>`;

    if($('.primary-information-tab .fuel-Surchrg-switch').is(":checked")){
      els.fuelSurchrgDiscTogglerDiv.append(fuelSurchrgDiscYesSpan);
    } else {
      els.fuelSurchrgDiscTogglerDiv.append(fuelSurchrgDiscNoSpan);
    }

    createOrUpdateRetailerJson1();
  }

  function addFacilityAddressDetails(supplyChainfacility,isActive){
    let cmrAddress = {};
    cmrAddress.cadAddressType = '';
    cmrAddress.cadContactNamePrefix = '';
    cmrAddress.cadLocationName = supplyChainfacility.facName;
    cmrAddress.cadAddressId = supplyChainfacility.facCode;
    cmrAddress.cadFacId = supplyChainfacility.facId;
    cmrAddress.cadContactName = supplyChainfacility.facContactName;
    cmrAddress.cadContactLastName = '';
    cmrAddress.cadContactEmail = supplyChainfacility.facContactEmail;
    cmrAddress.cadMobilePhoneCountryCode = '';
    cmrAddress.cadMobilePhoneAreaCode = '';
    cmrAddress.cadMobilePhone = '';
    cmrAddress.cadOfficePhoneCountryCode = '';
    cmrAddress.cadOfficePhoneAreaCode = '';
    cmrAddress.cadOfficePhone = supplyChainfacility.facContactPhone;
    cmrAddress.cadOfficePhoneExt = '';
    cmrAddress.cadAddress1 = supplyChainfacility.facAddressLine1;
    cmrAddress.cadAddress2 = supplyChainfacility.facAddressLine2;
    cmrAddress.cadCity = supplyChainfacility.facCity;
    cmrAddress.cadState = supplyChainfacility.facState;
    cmrAddress.cadCountry = supplyChainfacility.facCountry;
    cmrAddress.cadZipcode = supplyChainfacility.facZipcode;
    cmrAddress.cadStdAddress1 = cmrAddress.cadAddress1;
    cmrAddress.cadStdAddress2 = cmrAddress.cadAddress2;
    cmrAddress.cadStdCity = cmrAddress.cadCity;
    cmrAddress.cadStdState = cmrAddress.cadState;
    cmrAddress.cadStdCountry = cmrAddress.cadCountry;
    cmrAddress.cadStdZipcode = cmrAddress.cadZipcode;
    cmrAddress.cadAddressValidated = 1;
    cmrAddress.cadUseStdAddress = 1;
    cmrAddress.cadCommercialAddrFlag = '';
    cmrAddress.cadActive = isActive;

    retailer.retailerAddresses.push(cmrAddress);
  }

  function addShippingAddressDetails(shippingService,isActive){
    let rtlShippingAddress = {};

    rtlShippingAddress.cdmId = shippingService.cdmId;
    rtlShippingAddress.cdmDomain = shippingService.cdmDomain;
    rtlShippingAddress.cdmValue = shippingService.cdmMeaning;
    rtlShippingAddress.cdmMeaning = shippingService.cdmMeaning;
    rtlShippingAddress.cdmDescription = isActive;
    rtlShippingAddress.cdmCreatedDate = shippingService.cdmCreatedDate;
    rtlShippingAddress.cdmCreatedTime = shippingService.cdmCreatedTime;
    rtlShippingAddress.cdmCreatedBy = shippingService.cdmCreatedBy;
    rtlShippingAddress.cdmModifiedDate = shippingService.cdmModifiedDate;
    rtlShippingAddress.cdmModifiedTime = shippingService.cdmModifiedTime;
    rtlShippingAddress.cdmModifiedBy = shippingService.cdmModifiedBy; 
    rtlShippingAddress.cdmVersionNo = shippingService.cdmVersionNo;
    rtlShippingAddress.cdmSortOrder = shippingService.cdmSortOrder;
    rtlShippingAddress.cdmRetailerId = shippingService.cdmRetailerId;
    rtlShippingAddress.cdmPartnerId = shippingService.cdmPartnerId;
    rtlShippingAddress.cdmFacilityId = shippingService.cdmFacilityId;
    retailer.retailerShipping.push(rtlShippingAddress);
  }

  function updateOtherInfo(reviewSection, elsScope, addressType){
    if (elsScope.retPrefix.val()) {
      contactName = elsScope.retPrefix.val()+" "+elsScope.retFirstName.val()+" "+elsScope.retLastName.val();
    } else {
      contactName = elsScope.retFirstName.val()+" "+elsScope.retLastName.val();
    }
    reviewSection.revContactPersonName.html(contactName);
    reviewSection.revEmailAddress.html(elsScope.retEmail.val());

    if(addressType === 'Primary'){
      if(elsScope.mobilePhone.val()){
        mobileNumber = "M: ";
        mobileNumber = mobileNumber.concat(elsScope.mobileCounryCode.val());
        if(elsScope.country.val() == 'US' || elsScope.country.val() == 'CA'){
        mobileNumber = mobileNumber.concat(" "+elsScope.mobileAreaCode.val()+" ");
        }
        mobileNumber = mobileNumber.concat(elsScope.mobilePhone.val());
        reviewSection.revMobileNumber.html(mobileNumber);
      }else{
        reviewSection.revMobileNumber.html('');
      }
  
      officeNumber = "O: ";
      officeNumber = officeNumber.concat(elsScope.officeCounryCode.val());
      if(elsScope.country.val() == 'US' || elsScope.country.val() == 'CA'){
      officeNumber = officeNumber.concat(" "+elsScope.officeAreaCode.val()+" ");
      }
      officeNumber = officeNumber.concat(elsScope.officePhone.val());
      if(elsScope.officeExt.val()){
        officeNumber = officeNumber.concat(" Ext: "+elsScope.officeExt.val());
      }
      reviewSection.revOfficeNumber.html(officeNumber);
    }
    if(addressType === 'Shipping'){
      const shippingTabSwitchElement = shippingTab.find(elementsMap.sharePrimarySwitch);
      const shippingTabSwitchElementFlag = shippingTabSwitchElement.prop("checked");
      if(shippingTabSwitchElementFlag){
        if(elsScope.mobilePhone.val()){
          mobileNumber = "M: ";
          mobileNumber = mobileNumber.concat(elsScope.mobileCounryCode.val());
          if(elsScope.mobileCounryCode.val() === '+1'){
          mobileNumber = mobileNumber.concat(" "+elsScope.mobileAreaCode.val()+" ");
          }
          mobileNumber = mobileNumber.concat(elsScope.mobilePhone.val());
          reviewSection.revMobileNumber.html(mobileNumber);
        }else{
          reviewSection.revMobileNumber.html('');
        }
    
        officeNumber = "O: ";
        officeNumber = officeNumber.concat(elsScope.officeCounryCode.val());
        if(elsScope.officeCounryCode.val() == '+1'){
        officeNumber = officeNumber.concat(" "+elsScope.officeAreaCode.val()+" ");
        }
        officeNumber = officeNumber.concat(elsScope.officePhone.val());
        if(elsScope.officeExt.val()){
          officeNumber = officeNumber.concat(" Ext: "+elsScope.officeExt.val());
        }
        reviewSection.revOfficeNumber.html(officeNumber);
      }else{
        if(elsScope.mobilePhoneShip.val()){
          mobileNumber = "M: ";
          mobileNumber = mobileNumber.concat(elsScope.mobileCountryCodeShip.val());
          if(elsScope.mobileCountryCodeShip.val() === '+1'){
          mobileNumber = mobileNumber.concat(" "+elsScope.mobileAreaCodeShip.val()+" ");
          }
          mobileNumber = mobileNumber.concat(elsScope.mobilePhoneShip.val());
          reviewSection.revMobileNumber.html(mobileNumber);
        }else{
          reviewSection.revMobileNumber.html('');
        }
    
        officeNumber = "O: ";
        officeNumber = officeNumber.concat(elsScope.officeCountryCodeShip.val());
        if(elsScope.officeCountryCodeShip.val() == '+1'){
        officeNumber = officeNumber.concat(" "+elsScope.officeAreaCodeShip.val()+" ");
        }
        officeNumber = officeNumber.concat(elsScope.officePhoneShip.val());
        if(elsScope.officeExt.val()){
          officeNumber = officeNumber.concat(" Ext: "+elsScope.officeExt.val());
        }
        reviewSection.revOfficeNumber.html(officeNumber);
      }
      
    }
    if(addressType === 'Billing'){
      const billingTabSwitchElement = billingTab.find(elementsMap.sharePrimarySwitch);
      const billingTabSwitchElementFlag = billingTabSwitchElement.prop("checked");
      if(billingTabSwitchElementFlag){
        if(elsScope.mobilePhone.val()){
          mobileNumber = "M: ";
          mobileNumber = mobileNumber.concat(elsScope.mobileCounryCode.val());
          if(elsScope.mobileCounryCode.val() === '+1'){
          mobileNumber = mobileNumber.concat(" "+elsScope.mobileAreaCode.val()+" ");
          }
          mobileNumber = mobileNumber.concat(elsScope.mobilePhone.val());
          reviewSection.revMobileNumber.html(mobileNumber);
        }else{
          reviewSection.revMobileNumber.html('');
        }
    
        officeNumber = "O: ";
        officeNumber = officeNumber.concat(elsScope.officeCounryCode.val());
        if(elsScope.officeCounryCode.val() === '+1'){
        officeNumber = officeNumber.concat(" "+elsScope.officeAreaCode.val()+" ");
        }
        officeNumber = officeNumber.concat(elsScope.officePhone.val());
        if(elsScope.officeExt.val()){
          officeNumber = officeNumber.concat(" Ext: "+elsScope.officeExt.val());
        }
        reviewSection.revOfficeNumber.html(officeNumber);
      }else{
        if(elsScope.mobilePhoneBill.val()){
          mobileNumber = "M: ";
          mobileNumber = mobileNumber.concat(elsScope.mobileCountryCodeBill.val());
          if(elsScope.mobileCountryCodeBill.val() === '+1'){
          mobileNumber = mobileNumber.concat(" "+elsScope.mobileAreaCodeBill.val()+" ");
          }
          mobileNumber = mobileNumber.concat(elsScope.mobilePhoneBill.val());
          reviewSection.revMobileNumber.html(mobileNumber);
        }else{
          reviewSection.revMobileNumber.html('');
        }
    
        officeNumber = "O: ";
        officeNumber = officeNumber.concat(elsScope.officeCountryCodeBill.val());
        if(elsScope.officeCountryCodeBill.val() === '+1'){
        officeNumber = officeNumber.concat(" "+elsScope.officeAreaCodeBill.val()+" ");
        }
        officeNumber = officeNumber.concat(elsScope.officePhoneBill.val());
        if(elsScope.officeExt.val()){
          officeNumber = officeNumber.concat(" Ext: "+elsScope.officeExt.val());
        }
        reviewSection.revOfficeNumber.html(officeNumber);
      }
      
    }
    
    reviewSection.address1.html(elsScope.address1.val());
    reviewSection.address2.html(elsScope.address2.val());
    reviewSection.city.html(elsScope.city.val());
    if(elsScope.country.val() == 'US' || elsScope.country.val() == 'CA'){
      reviewSection.state.html(elsScope.state.val());
    }else{
      reviewSection.state.html(elsScope.nonUSCAstate.val());
    }
    reviewSection.zipCode.html(elsScope.zipCode.val());
    reviewSection.county.html(elsScope.county.val());
    reviewSection.country.html(elsScope.country.find("option:selected").text());

    createOrUpdateRetailerJson2(addressType, elsScope);
  }

  function createOrUpdateRetailerJson1(){
    //create or update retailer JSON
    if(!isExistingRetailer){
      retailer.rtlType = "C";
      retailer.rtlStatus = "A";
      retailer.enrollmentConfigs = {
        enrollments: wizardElement.data("rtl-type")
      };
    }
    retailer.rtlName = els.companyName.val();
    retailer.rtlTaxId = els.taxId.val();
    /*retailer.retailerFedExIds = {
      greenwoodFedExId: els.greenwoodFedexId.val(),
      fontanaFedExId: els.fontanaFedExId.val(),
      greenwoodFacId:els.facId1.val(),
      fontanaFacId:els.facId2.val()
    };*/
    retailer.rtlWebUrl = els.primaryUrl.val();
    const fedexCanCallElement = primaryTab.find(elementsMap.fedexCanCall);
    retailer.rtlOkToCall = fedexCanCallElement.prop("checked");
    const shippingTabSwitchElement = shippingTab.find(elementsMap.sharePrimarySwitch);
    retailer.rtlShipAccEqPrimary = shippingTabSwitchElement.prop("checked");
    const billingTabSwitchElement = billingTab.find(elementsMap.sharePrimarySwitch);
    retailer.rtlBillAccEqPrimary = billingTabSwitchElement.prop("checked");
    retailer.rtlTier=parseInt(els.merchantTier.val());
 //   retailer.retailerAddresses = [];
    const masterAccountToggleCheckboxElement = primaryTab.find(elsPrimarySection.masterAccountToggleCheckbox);
    const managedByMasteraccountToggleCheckboxElement = primaryTab.find(elsPrimarySection.managedByMasteraccountToggleCheckbox);
    const masteraccountDropdownElement = primaryTab.find(elsPrimarySection.masteraccountDropdown);
    
    if(masterAccountToggleCheckboxElement.prop("checked")){
      retailer.rtlMasterFlag=true;
      retailer.rtlVirtualFlag=false;
      retailer.rtlMasterAccountId=null;
    }

    if(managedByMasteraccountToggleCheckboxElement.prop("checked")){
      retailer.rtlMasterFlag=false;
      retailer.rtlVirtualFlag=true;
      retailer.rtlMasterAccountId=masteraccountDropdownElement.val();
    }
    //retailer.rtlMasterFlag=masterAccountToggleCheckboxElement.prop("checked");
    //retailer.rtlVirtualFlag=managedByMasteraccountToggleCheckboxElement.prop("checked");
    //retailer.rtlMasterAccountId=masteraccountDropdownElement.val();
    //alert(masterAccountToggleCheckboxElement.prop("checked"));
    //alert(managedByMasteraccountToggleCheckboxElement.prop("checked"));
    //alert(masteraccountDropdownElement.val());
    
  }

  function createOrUpdateRetailerJson2(addressType, elsScope){
    if(addressType == 'Primary'){
      retailer.rtlContactNamePrefix = elsScope.retPrefix.val();
      retailer.rtlContactFirstName = elsScope.retFirstName.val();
      retailer.rtlContactLastName = elsScope.retLastName.val();
      retailer.rtlEmail = elsScope.retEmail.val();
      retailer.rtlMobilePhoneCountryCode = elsScope.mobileCounryCode.val();
      retailer.rtlMobilePhoneAreaCode = elsScope.mobileAreaCode.val();
      retailer.rtlMobilePhone = elsScope.mobilePhone.val();
      retailer.rtlOfficePhoneCountryCode = elsScope.officeCounryCode.val();
      retailer.rtlOfficePhoneAreaCode = elsScope.officeAreaCode.val();
      retailer.rtlOfficePhone = elsScope.officePhone.val();
      retailer.rtlOfficePhoneExt = elsScope.officeExt.val();

      retailer.rtlAddress1 = elsScope.address1.val();
      retailer.rtlAddress2 = elsScope.address2.val();
      retailer.rtlCity = elsScope.city.val();
      if(elsScope.country.val() == 'US' || elsScope.country.val() == 'CA'){
        retailer.rtlState = elsScope.state.val();
      }else{
        retailer.rtlState = elsScope.nonUSCAstate.val();
      }
      retailer.rtlConCode = elsScope.country.val();
      retailer.rtlZip = elsScope.zipCode.val();
      retailer.rtlCounty = elsScope.county.val();
     
      if($('.primary-information-tab .insight-feed-switch').is(":checked")){
        retailer.rtlInsightFeedFlag = true;
      } else {
        retailer.rtlInsightFeedFlag = false;
      }

      if($('.primary-information-tab .fuel-Surchrg-switch').is(":checked")){
        retailer.rtlFuelSurchrgDiscFlag = true;
      } else {
        retailer.rtlFuelSurchrgDiscFlag = false;
      }
  
      if($('.primary-information-tab .direct-bill-switch').is(":checked")){
        retailer.directBillCustomerFlag = true;
      } else {
        retailer.directBillCustomerFlag = false;
      }

      retailer.childRetailers = [];
      if(elsScope.affMerchantSwitchery.is(":checked")){  
        if($(".affMerchantNameValue").length == 0){
          $('.merchants-target-section').hide();
        } else {
          $('.merchants-target-section').show();
        }      
        $.each($(".affMerchantNameValue"), function(ind, e){
          let childRtlr = {};
          childRtlr.chrName = $(e).val();
          retailer.childRetailers.push(childRtlr);
        });
      } else {
        $('.merchants-target-section').hide();
      }

    } else {
      //create cmrAddress and set to JSON
      let cmrAddress = {};
      const retailerAddresses = retailerObj.retailerAddresses;
      if(_.isObject(retailerAddresses) && retailerAddresses.length > 0){
        cmrAddress = _(retailerAddresses).findWhere({cadAddressType: addressType});
        if(!_.isObject(cmrAddress)){
          cmrAddress = {};
        }
      }
      cmrAddress.cadAddressType = addressType;
      cmrAddress.cadContactNamePrefix = elsScope.retPrefix.val();
      cmrAddress.cadContactName = elsScope.retFirstName.val();
      cmrAddress.cadContactLastName = elsScope.retLastName.val();
      cmrAddress.cadContactEmail = elsScope.retEmail.val();

      if(addressType =='Shipping'){
        const shippingTabSwitchElement = shippingTab.find(elementsMap.sharePrimarySwitch);
        const shippingTabSwitchElementFlag = shippingTabSwitchElement.prop("checked");
        if(shippingTabSwitchElementFlag){
          if(elsScope.country.val() == 'US' || elsScope.country.val() == 'CA'){
            cmrAddress.cadMobilePhoneAreaCode = elsScope.mobileAreaCode.val();
            cmrAddress.cadOfficePhoneAreaCode = elsScope.officeAreaCode.val();
          }else{
            cmrAddress.cadMobilePhoneAreaCode = '';
            cmrAddress.cadOfficePhoneAreaCode = '';
          }
          cmrAddress.cadMobilePhoneCountryCode = elsScope.mobileCounryCode.val();
          cmrAddress.cadMobilePhone = elsScope.mobilePhone.val();
          cmrAddress.cadOfficePhoneCountryCode = elsScope.officeCounryCode.val();
          cmrAddress.cadOfficePhone = elsScope.officePhone.val();
        }else{
          if(elsScope.country.val() == 'US' || elsScope.country.val() == 'CA'){
            cmrAddress.cadMobilePhoneAreaCode = elsScope.mobileAreaCodeShip.val();
            cmrAddress.cadOfficePhoneAreaCode = elsScope.officeAreaCodeShip.val();
          }else{
            cmrAddress.cadMobilePhoneAreaCode = '';
            cmrAddress.cadOfficePhoneAreaCode = '';
          }
          cmrAddress.cadMobilePhoneCountryCode = elsScope.mobileCountryCodeShip.val();
          cmrAddress.cadMobilePhone = elsScope.mobilePhoneShip.val();
          cmrAddress.cadOfficePhoneCountryCode = elsScope.officeCountryCodeShip.val();
          cmrAddress.cadOfficePhone = elsScope.officePhoneShip.val();
        }
        
        cmrAddress.cadOfficePhoneExt = elsScope.officeExt.val();
      }
  
      if(addressType =='Billing'){
        const billingTabSwitchElement = billingTab.find(elementsMap.sharePrimarySwitch);
        const billingTabSwitchElementFlag = billingTabSwitchElement.prop("checked");
        if(billingTabSwitchElementFlag){
          if(elsScope.country.val() == 'US' || elsScope.country.val() == 'CA'){
            cmrAddress.cadMobilePhoneAreaCode = elsScope.mobileAreaCode.val();
            cmrAddress.cadOfficePhoneAreaCode = elsScope.officeAreaCode.val();
          }else{
            cmrAddress.cadMobilePhoneAreaCode = '';
            cmrAddress.cadOfficePhoneAreaCode = '';
          }
          cmrAddress.cadMobilePhoneCountryCode = elsScope.mobileCounryCode.val();
          cmrAddress.cadMobilePhone = elsScope.mobilePhone.val();
          cmrAddress.cadOfficePhoneCountryCode = elsScope.officeCounryCode.val();
          cmrAddress.cadOfficePhone = elsScope.officePhone.val();
        }else{
          if(elsScope.country.val() == 'US' || elsScope.country.val() == 'CA'){
            cmrAddress.cadMobilePhoneAreaCode = elsScope.mobileAreaCodeBill.val();
            cmrAddress.cadOfficePhoneAreaCode = elsScope.officeAreaCodeBill.val();
          }else{
            cmrAddress.cadMobilePhoneAreaCode = '';
            cmrAddress.cadOfficePhoneAreaCode = '';
          }
          cmrAddress.cadMobilePhoneCountryCode = elsScope.mobileCountryCodeBill.val();
          cmrAddress.cadMobilePhone = elsScope.mobilePhoneBill.val();
          cmrAddress.cadOfficePhoneCountryCode = elsScope.officeCountryCodeBill.val();
          cmrAddress.cadOfficePhone = elsScope.officePhoneBill.val();
        }
        
        cmrAddress.cadOfficePhoneExt = elsScope.officeExt.val();
      }
      cmrAddress.cadAddress1 = elsScope.address1.val();
      cmrAddress.cadAddress2 = elsScope.address2.val();
      cmrAddress.cadCity = elsScope.city.val();
      if(elsScope.country.val() == 'US' || elsScope.country.val() == 'CA'){
        cmrAddress.cadState = elsScope.state.val();
      }else{
        cmrAddress.cadState = elsScope.nonUSCAstate.val();
      }
      cmrAddress.cadCountry = elsScope.country.val();
      cmrAddress.cadZipcode = elsScope.zipCode.val();
      cmrAddress.cadCounty = elsScope.county.val();

      //hard code values
      cmrAddress.cadStdAddress1 = cmrAddress.cadAddress1;
      cmrAddress.cadStdAddress2 = cmrAddress.cadAddress2;
      cmrAddress.cadStdCity = cmrAddress.cadCity;
      cmrAddress.cadStdState = cmrAddress.cadState;
      cmrAddress.cadStdCountry = cmrAddress.cadCountry;
      cmrAddress.cadStdZipcode = cmrAddress.cadZipcode;
      cmrAddress.cadAddressValidated = 1;
      cmrAddress.cadUseStdAddress = 1;
      cmrAddress.cadCommercialAddrFlag = elsScope.commercialAddrFlag.val();

      retailer.retailerAddresses.push(cmrAddress);
    }
  }

  function showConfirmationModal(e){
    e.preventDefault();
    confirmationModal.modal("show");
  }

  function onSubmit(e){
    e.preventDefault();
    saveNow({url: submitUrl, success: onSuccess, error: onError});
  }

  function saveNow({url, success, error}){
    submitModalFlow.showLoadingModal();
    $.ajax({
      data: {
        '_retailer_WAR_retailerportlet_retailerJson': JSON.stringify(retailer)
      },
      url: url,
      dataType:"JSON",
      type: 'POST',
      success: success,
      error: error
    });
  }

  function onSuccess(response){
    if(response && response.status == 'Success') {
   	  EditChecker.setPageClean();
   	  submitModalFlow.showSuccessModal();
   	  setTimeout(function() {
   		  //const asnDetailUrl = wizardElement.data("asn-detail-url");
   	    location.href = renderUrl;
   	  }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    }else{
 	    submitModalFlow.showFailureModal();
    }
  }

  function onError(){
	  submitModalFlow.showFailureModal();
  }

}



// WEBPACK FOOTER //
// ./src/pages/maintainRetailer/ReviewTab.js